import { LoginOption } from './login-option.model';

export const loginOptions: LoginOption[] = [
    {
        label: 'foo',
        loginUri: '/foo',
    },
];

export const loginOption: LoginOption = loginOptions[0];
